import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS } from '../const.config';

// manage videos module configurations
export const LISTING_MOVIES_COLUMNS = [
  {
    id: 'title',
    label: 'Video Name',
    width: '20%',
    align: 'left',
    dataKey: 'title',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
];

export const LISTING_MOVIES_ACTIONS = [
  {
    action: ACTIONS.DELETE.value,
    label: ACTIONS.DELETE.label,
  },
];

// manage series module configurations
export const LISTING_SERIES_COLUMNS = [
  {
    id: 'title',
    label: 'Series Name',
    width: '20%',
    align: 'left',
    dataKey: 'title',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
];

export const LISTING_SERIES_ACTIONS = [
  {
    action: ACTIONS.DELETE.value,
    label: ACTIONS.DELETE.label,
  },
];

// manage show module configurations
export const LISTING_SHOWS_COLUMNS = [
  {
    id: 'title',
    label: 'Show Name',
    width: '20%',
    align: 'left',
    dataKey: 'title',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
];

export const LISTING_SHOWS_ACTIONS = [
  {
    action: ACTIONS.DELETE.value,
    label: ACTIONS.DELETE.label,
  },
];
